import { motion } from 'framer-motion';

interface PathLayoutProps {
  children: React.ReactNode;
}

export function PathLayout({ children }: PathLayoutProps) {
  return (
    <div className="relative">
      {/* Path Container */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="relative"
      >
        {/* Center Line */}
        <div className="absolute left-1/2 top-0 bottom-0 w-1 -translate-x-1/2 bg-gradient-to-b from-primary/50 via-purple-500/50 to-blue-500/50 rounded-full" />

        {/* Units Path */}
        <div className="flex flex-col items-center space-y-8 py-8">
          {children}
        </div>
      </motion.div>
    </div>
  );
}
